import React from 'react'
import { Box } from "@mui/material"

import { AppLinksBlock } from "@components"

export default function globalDownloadColumn() {

	return {
		name: 'name',
		render: (
			value, {
				executionHasGenerations,
				executionHasExports,
				id_report_execution
			}) => {

			return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<AppLinksBlock
					reportExecutionID={id_report_execution}
					downMultiExport={executionHasExports}
					downMultiReport={executionHasGenerations}
					dor={false}
					lor={false}
					position={false}
					showHistory={false}
				/>
			</Box>
		}
	}
}